import {useCallback, useEffect, useRef, useState} from "react"
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import TextField from "@base/Inputs/Text"
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import useStyles from './Style';
import escolaService from "@services/EscolaService"
import Chip from '@material-ui/core/Chip';
import Toast from "@base/Toast";
import {Grid} from "@material-ui/core"
import ButtonPrimary from "../../base/Button/Button";
import AddIcon from '@material-ui/icons/Add'
import CircularProgress from '@material-ui/core/CircularProgress'
import {objetoPostalMask} from '@helpers/MaskHelper';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import Checkbox from '@material-ui/core/Checkbox';
import VisualizadorDeArquivo from "@base/VisualizadorDeArquivo";
import Dialog from "@base/Dialog";

const imageMimeTypes = ['image/jpeg', 'image/png'];
const regex = /^[A-Za-z]{2}\d{14}$/;

export const RegistroArquivosSelecionados = (props) => {
  const classes = useStyles();

  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModalVisualizarArquivo, setOpenModalVisualizarArquivo] = useState(false);
  const [arquivoSelecionadoCodigo, setArquivoSelecionadoCodigo] = useState("");
  const [arquivoSelecionado, setArquivoSelecionado] = useState([]);
  
  const tratarCodigo = (codigo) => {
    const regex = /[.\-_].*/;
    codigo = codigo.replace(regex, '');
    if (codigo.length > 16) {
      codigo = codigo.substring(0, 16);
    }
    return codigo
  }

  const cartoesFormatados = useCallback((cartoes) => {
    const temp = [];
    for (let i = 0; i < cartoes.length; i++) {
      const novoCodigo = tratarCodigo(cartoes[i].name)
      const isImage = imageMimeTypes.includes(cartoes[i].type);

      temp.push(
        {
          codigo: novoCodigo,
          arquivo: cartoes[i],
          mensagem: isImage ? regex.test(novoCodigo) ? "Não Registrado" : "O código deve possuir 16 caracteres, iniciando com 2 letras." : "Arquivo não é uma imagem",
          status: isImage && regex.test(novoCodigo) ? "NAO_REGISTRADO" : "ERRO",
          nivel: 0
        }
      );
    }
    setLista(temp);
  }, [setLista])

  useEffect(() => cartoesFormatados(props.arquivos), [props.arquivos, props.refresh, cartoesFormatados]);

  const toastRef = useRef(null);

  const registrarCartao = async () => {
    const novaLista = [...lista];
    setLista(novaLista);

    setLoading(true);

    const promessas = lista.map(async (l, i) => {
      if (l.status === "REGISTRADO") {
        removerCartao(i);
      } else {
        const config = {headers: {'content-type': 'multipart/form-data'}};
        const obj = new FormData();
        obj.append('processo', props.processo.id);
        obj.append('origem', props.origem);
        obj.append('codigoEscola', props.escola.codigoInep);
        obj.append('arquivoCartao', l.arquivo);

        if (l.codigo !== "DESABILITADO") {
          obj.append('codigo', l.codigo);
        }
        if (props.numeroObjetoPostal !== null && props.numeroObjetoPostal !== "") {
          obj.append('numeroObjetoPostal', props.numeroObjetoPostal);
        }
        if (l.nivel !== 0) {
          obj.append("nivel", l.nivel);
        }

        try {
          const resultado = await escolaService.registrarCartao(
            props.processo.id,
            props.escola.codigoInep,
            obj,
            config
          );

          if (resultado.status === 200) {
            novaLista[i] = {
              ...novaLista[i],
              mensagem: "Cartão recebido com sucesso!",
              status: "REGISTRADO"
            };
            toastRef.current.show("success", "Cartão recebido com sucesso!");
          }

        } catch (error) {
          novaLista[i] = {
            ...novaLista[i],
            mensagem: error.response?.data?.mensagens?.[0] ? `erro ${error.response.data.mensagens[0]}` : 'Erro ao receber o cartão',
            status: "ERRO_SERVICO"
          }
          toastRef.current.show("erro", "Erro ao receber cartão");
        }
      }

    });
    await Promise.all(promessas);
    setLista(novaLista);
    setLoading(false);
    props.onRegistrar();
  };


  const mudarcodigo = (i, codigo) => {
    const novaLista = [...lista];
    novaLista[i] = {...novaLista[i],
      codigo: codigo,
      status: regex.test(codigo) ? "NAO_REGISTRADO" : "ERRO",
      mensagem: regex.test(codigo) ? "Não Registrado" : "O código deve possuir 16 caracteres, iniciando com 2 letras." };
    setLista(novaLista);
  };

  const adicionarNivel = (i, nivel) => {
    const novaLista = [...lista];
    novaLista[i] = {...novaLista[i],
      nivel: nivel,
      mensagem: "Não Registrado"
    };
    setLista(novaLista);
  };

  const removerCartao = (i) => {
    const novaLista = lista.filter((item, index) => index !== i);
    setLista(novaLista);
  };

  const marcarCartaoIlegivel = (i) => {
    const novaLista = [...lista];
    if (novaLista[i].status === "DESABILITADO"){
      novaLista[i] = {
        ...novaLista[i],
        mensagem: "O código deve possuir 16 caracteres, iniciando com 2 letras.",
        status: "ERRO"
      }
    } else {
      novaLista[i] = {
        ...novaLista[i],
        codigo: "",
        status: "DESABILITADO",
        mensagem: "Digite o nível do cartão."
      }
    }
    setLista(novaLista);
  }

  const handleClick = (codigo, arquivo) => {
    setArquivoSelecionadoCodigo(codigo);
    setArquivoSelecionado(arquivo);
    setOpenModalVisualizarArquivo(true);
  }
  const isRegistrarDesabilitado = () => {
    return lista.some(item => item.status === "ERRO") || loading;
  };
  return (
    <>
      <Toast ref={toastRef}/>
      <List>
        {lista.map((a, key) => (


          <ListItem className={classes.imageList} key={key}>
            <Grid container justify={"space-between"} alignItems={"center"} className={classes.root}>
              <Grid item sm={2} onClick={() => handleClick(a.codigo, a.arquivo)} style={{ cursor: 'pointer' }}>
                <VisualizadorDeArquivo
                  blob={a.arquivo}
                  rotate={true}
                />
              </Grid>
              <Grid item sm={2}>
                <TextField error={a.status === "ERRO"} disabled={a.status === "DESABILITADO" || a.status === "REGISTRADO"} autoFocus label="Código do Cartão" value={a.codigo} onChange={(e) => {
                  mudarcodigo(key, objetoPostalMask(e.target.value))
                }}/>
                {a.status === "DESABILITADO" &&
                  <TextField error={a.status === "DESABILITADO" && a.nivel === 0} autoFocus label="Nível do Cartão" onChange={(e) => adicionarNivel(key, e.target.value)}/>
                  }
              </Grid>

              <Grid  item sm={6} className={classes.actions}>
                <Grid sm={8} style={{textAlign: "center"}} >
                  <Chip
                    label={a.mensagem}
                    color={a.status === "ERRO" || a.status ===  "ERRO_SERVICO" || (a.status === "DESABILITADO" && a.nivel === 0) ? "secondary" : a.status === "REGISTRADO" ? "primary" : "deafault"}
                  />
                </Grid>
                <Grid sm={6} style={{textAlign: "end"}}>
                  {a.mensagem !== "Cartão recebido com sucesso!" ?
                    <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={a.status === "DESABILITADO"}
                          onChange={() => marcarCartaoIlegivel(key)}
                        />
                      }
                      label="Código Ilegivel"
                    />
                    <IconButton aria-label="Delete" onClick={() => removerCartao(key)}>
                      <DeleteIcon/>
                    </IconButton>
                      </>
                    :
                    <IconButton aria-label="Delete" onClick={() => removerCartao(key)}>
                      <CloseIcon/>
                    </IconButton>
                  }
                </Grid>
              </Grid>
            </Grid>

          </ListItem>
        ))}
      </List>

      <Grid alignItems="center" container spacing={3}>
        <Grid item sm={9}>
          <ButtonPrimary
            onClick={registrarCartao}
            name="Registrar Cartões"
            startIcon={loading ? <CircularProgress size={16}/> : <AddIcon/>}
            disabled={isRegistrarDesabilitado()}
          />
        </Grid>
      </Grid>

      {openModalVisualizarArquivo &&
        <Dialog
          maxWidth={"lg"}
          fullWidth={true}
          closeDialog={() => setOpenModalVisualizarArquivo(false)}
          openDialog={openModalVisualizarArquivo}
          title={`Cartão ${arquivoSelecionadoCodigo}`}
          actions={[]}
        >
          <VisualizadorDeArquivo
            blob={arquivoSelecionado}
          />
        </Dialog>
      }
    </>

  );
}

export default RegistroArquivosSelecionados;
